import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Timeline from 'Components/AdvisorApp/Viewport/Household/LandingPage/NewTimeline';

const styles = theme => ({
  container: {}, // Not used -- just to get around a console error
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
  },
  timelineEventsContainer: {
    margin: theme.spacing(3, 0, 0),
  },
  timelineEventsEvent: {
    maxHeight: theme.dimensions.md,
  },
  timelineHeader: {
    display: 'flex',
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.facet.lightGray2}`,
    alignItems: 'unset',
    justifyContent: 'unset',
    flexDirection: 'column',
  },
});

const TimelineView = ({
  className,
  classes,
}) => {
  return (
    <Timeline
      classes={{
        root: classNames(classes.root, className),
        eventsContainer: classes.timelineEventsContainer,
        timelineEventsEvent: classes.timelineEventsEvent,
        header: classes.timelineHeader,
      }}
    />
  );
};

TimelineView.defaultProps = {
  className: '',
};

TimelineView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TimelineView);
